<template>
  <div class="login" :style="{backgroundImage:`url(${backgroundImage})`}">
    <div class="login-img">
      <div v-if="library_id==776" class="left_top">
        <img src="@/assets/images/aqt-sd.png">
      </div>
      <div class="text">
        <img v-if="library_id==776&&gjType=='zheshe'" src="@/assets/images/aqt-zs.png">
        <img v-else-if="library_id==776&&gjType=='ziran'" src="@/assets/images/aqt-zr.png">
        <img v-else src="@/assets/images/aqt-logo2.png">
      </div>
    </div>
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <Form ref="form" :model="form" label-position="left" :rules="rules"
                @keydown.enter.native="handleSubmit('form')">
            <FormItem prop="user_type" label="角色" style="display: -webkit-box">
              <RadioGroup v-model="form.user_type" @on-change="radioChange">
                <Radio :label="ite.label" v-for="ite in typeList" :key="ite.label">
                  <span>{{ ite.name }}</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="username" v-if="form.user_type==1">
              <Input prefix="ios-contact" v-model="form.username" placeholder="请输入用户名"/>
            </FormItem>
            <FormItem prop="password" v-if="form.user_type==1">
              <Input prefix="ios-unlock" type="password" v-model="form.password" placeholder="请输入密码"/>
            </FormItem>
            <FormItem prop="verCode" v-if="form.user_type==1">
              <Input class="inputVercod" prefix="md-checkmark-circle" v-model="form.verCode"
                     placeholder="请输入验证码"/>
              <div class="code" @click="VerificationCode">{{ checkCode }}</div>
            </FormItem>

            <FormItem prop="tel" v-if="form.user_type!=1">
              <Input prefix="md-phone-portrait" v-model="form.tel" placeholder="请输入手机号"/>
            </FormItem>
            <FormItem prop="code" v-if="form.user_type!=1">
              <Input class="inputVercod" prefix="md-checkmark-circle" v-model="form.code"
                     placeholder="请输入验证码"/>
              <Button class="codeButton" :disabled="Prohibit"
                      @click="GetVerificationCode">{{ text }}
              </Button>
            </FormItem>

            <FormItem>
              <Button @click="handleSubmit('form')" :loading="loading" type="primary" long
                      :disabled="library_id?false:true">登录
              </Button>
            </FormItem>
            <p v-if="!library_id" style="color: red">*验证超时需要从<span style="color: #0a84ff;cursor: pointer"
                                                                   @click="goAqtyz">【优质资源】</span>平台重新进入【投审系统】</p>
          </Form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>

import Vue from "vue";
import store from "@/store";

const axios = require('axios')
export default {
  data() {
    const validatecheckCode = (rule, value, callback) => {
      if (value !== this.checkCode) {
        callback(new Error('验证码错误')) // '验证码错误'
      } else {
        callback()
      }
    }
    const validatechecktelCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (value.length != 6) {
        callback(new Error('验证码验证码长度为6位')) // '验证码错误'
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: {
        library_id: localStorage.getItem('libId'),
        user_type: 4,//1管理员2编辑 3专家 4作者
        code: '',//验证码
        username: '',
        password: '',
        tel: '',

        verCode: '',


      },
      checkCode: '',
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        verCode: [
          {required: true, trigger: 'blur', validator: validatecheckCode}
        ],


        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur"}
        ],
        code: [
          // {required: true, trigger: 'blur', message: '请输入验证码',}
          {required: true, trigger: 'blur', validator: validatechecktelCode}
        ],
      },
      userUrl: 'api/user/v1/ndividualinformation/user',
      menuData: [],
      backgroundImage: require('@/assets/images/login-bg.png'),

      typeList: [
        {
          label: 4,
          name: '作者'
        },
        {
          label: 3,
          name: '专家'
        },
        {
          label: 2,
          name: '编辑'
        },
        {
          label: 1,
          name: '管理员'
        }
      ],

      codes: "" /**验证验证码 */,
      Prohibit: false /**按钮禁用 */,
      text: "获取验证码" /**按钮文字 */,
      tels: "" /**验证手机号 */,
      num: 0,
      library_id: localStorage.getItem('libId'),
      gjType: localStorage.getItem('gjType'),
    }
  },
  methods: {
    //角色按钮变化
    radioChange(val) {
      let that = this
      this.$refs.form.resetFields()
      this.form.user_type = val
      if (this.form.user_type == 1) {
        this.form.username = ''
        this.form.password = ''
        this.form.verCode = ''
        this.VerificationCode(false)
      } else {
        this.form.tel = ''
        this.form.code = ''
        this.text = '获取验证码'
        this.codes = ''
        this.Prohibit = false
        this.tels = ''
        this.num = 0
      }
    },
    /************************************************************
     *
     * 验证码倒计时
     *
     ************************************************************/
    GetVerificationCode() {
      var that = this;

      if (that.form.tel == "") {
        //填写手机号
        that.$Message.error('请填写手机号');
        return;
      }
      if (that.form.tel.length != 11 || isNaN(Number(that.form.tel))) {
        //请填写正确电话号码
        that.$Message.error('请填写正确电话号码');
        return;
      }
      this.num = 60;
      if (that.Prohibit) {
        return;
      }

      function qiehan() {
        if (that.num > 1) {
          --that.num;
          that.text = "等" + that.num + "秒";
          that.Prohibit = true;
          setTimeout(function () {
            qiehan();
          }, 1000);
        } else {
          that.text = "获取验证码";
          that.Prohibit = false;
        }
      }

      qiehan();
      let a = {
        tel: that.form.tel,
        library_id: localStorage.getItem('libId')
      };
      that.$httpsencrypt
          .post("api/contributeweb/v3/login/getTelVerifCode", a)
          .then((val) => {
            that.codes = val.data;
            that.tels = a.tel
          })
          .catch((err) => {
            //发送验证码太频繁，请1小时后再试！
            that.$Message.error('发送验证码太频繁，请1小时后再试！');
          });
    },
    /** **********************************************************
     * 验证码
     ************************************************************/
    async VerificationCode(type = true) {
      let that = this;
      if (type) {
        // that.$store.dispatch('saveUserBehavior', {
        //   path: that.$route.path,
        //   name: '点击获取验证码按钮',
        //   other_id: '',
        //   type: '',
        // }).then(() => {
        // })
      }
      let condition = {
        type: 5,//1蒙语PC管理端 2汉语PC管理端 3 APP管理端 4统一检索PC端 5投审系统
      }
      that.checkCode = ""

      that.$httpsencrypt
          .post("api/user/v3/loginverifcode/getVerifCode", condition)
          .then((val) => {
            that.checkCode = val.data;
            if (val.code == 200) {
              that.checkCode = val.data;
            } else {
              that.$Message.error(val.message);
            }
          })
          .catch((err) => {
            //发送验证码太频繁，请1小时后再试！
            that.$Message.error('发送验证码太频繁，请1小时后再试！');
          });
    },
    /*****************************************************************
     *
     * 表单验证
     * @param   {name}             表单
     *
     *****************************************************************/
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          this.login()
        } else {
          this.$Message.error('请检查输入内容!')
        }
      })
    },

    /*****************************************************************
     *
     * 登录
     *
     *****************************************************************/
    async login() {
      let that = this
      // that.$store.dispatch('saveUserBehavior', {
      //   path: that.$route.path,
      //   name: '点击登录按钮',
      //   other_id: '',
      //   type: '',
      // }).then(() => {
      // })

      that.$httpsencrypt
          .post("api/contributeweb/v3/login/logins", that.form)
          .then((val) => {
            if (val.code == 200) {
              localStorage.setItem('userData', that.$crypto.set(JSON.stringify(val.data)))
              localStorage.setItem('userInfoMemberId', val.data.users_id)
              localStorage.setItem('user_type', val.data.user_type)
              that.$store.state.userInfo = JSON.stringify(val.data)
              that.loading = false
              setTimeout(function () {
                that.$router.replace({
                  path: '/home',
                  query: {
                    lib: that.$route.query.lib,
                    alis: that.$route.query.alis
                  }
                })
              }, 200)
            }
          })
          .catch((err) => {
            if (that.form.user_type == 1) {
              that.VerificationCode(false)
            }
            that.loading = false
          });

    },
    goAqtyz() {
      window.open('https://aqtresources.aqitai.com/#/login?lib_type=school', '_blank');
    }
  },
  created() {

    this.$clearLocalStorageExceptActivePages()
    sessionStorage.clear()
    this.$store.state.tabList = '[]'
    this.$store.state.userInfo = ''


    if (this.$route.query.lib) {
      localStorage.setItem('libId', this.$crypto.get(decodeURIComponent(this.$route.query.lib)))
    }
    if (this.$route.query.alis) {
      localStorage.setItem('gjType', this.$crypto.get(decodeURIComponent(this.$route.query.alis)))
    }
    this.library_id = localStorage.getItem('libId')?localStorage.getItem('libId'):''
    this.gjType = localStorage.getItem('gjType')?localStorage.getItem('gjType'):''
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  //background-image: url('./../../assets/images/login-bg.png');
  background-size: cover;
  background-position: center;
  position: relative;


  &-img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 550px;

    .text {
      position: relative;
      margin: 0 auto;
      height: 50%;
      width: 80%;
      top: calc(calc(100% - 250px) / 2.5);
      color: #ffffff;
      display: flex;
      justify-content: center;

      img {
        height: 250px;
        width: auto;
      }
    }

    .left_top {
      position: fixed;
      height: 90px;
      max-width: 300px;
      top: 30px;
      left: 20px;
      color: #ffffff;
      display: flex;
      justify-content: center;

      img {
        height: 100%;
        width: auto;
      }
    }
  }

  &-con {
    position: absolute;
    right: 200px;
    top: 50%;
    transform: translateY(-60%);
    width: 350px;

    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }

    .form-con {
      padding: 10px 0 0;
    }

    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }
  }


}
</style>

<style lang="less">
.form-con {
  .ivu-form-item-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .inputVercod {
      width: 70%;
    }

    .code {
      width: 28%;
      height: 32px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      font-size: 18px;
      text-align: center;
      color: #515a6e;
      line-height: 32px;
      cursor: pointer;
    }
  }
}

</style>
